import i18n from '../../../i18n';

const t = i18n.t.bind(i18n);

export function createdLetterLeadLine(
  mode: 'cover' | 'application',
  role: string,
  company: string,
): string {
  const tab = mode === 'cover'
    ? t('agent.canvas.tabs.coverLetter', 'Cover Letter')
    : t('agent.canvas.tabs.applicationNote', 'Application Note');
  const artifact = mode === 'cover'
    ? t('agent.engagement.artifact.coverLetter', 'cover letter')
    : t('agent.engagement.artifact.applicationLetter', 'application letter');
  return t('agent.engagement.createdLetter', {
    defaultValue: 'Created the **{{artifact}}** for **{{role}}**. It\'s open in the **{{tab}}** tab on the right.',
    artifact,
    role: `${role} at ${company}`,
    tab,
  });
}

export function draftingCoverLetterMessage(title: string, company: string): string {
  return t('agent.engagement.draftingCoverLetter', {
    defaultValue: 'Drafting your cover letter for **{{title}}** at **{{company}}**…',
    title,
    company,
  });
}

export function draftingApplicationLetterMessage(title: string, company: string): string {
  return t('agent.engagement.draftingApplicationLetter', {
    defaultValue: 'Drafting your application letter for **{{title}}** at **{{company}}**…',
    title,
    company,
  });
}

export function draftingApplicationNoteMessage(title: string, company: string): string {
  return t('agent.engagement.draftingApplicationNote', {
    defaultValue: 'Drafting your application note for **{{title}}** at **{{company}}**…',
    title,
    company,
  });
}

export function draftingCoverLetterWithTabMessage(title: string, company: string): string {
  const tab = t('agent.canvas.tabs.coverLetter', 'Cover Letter');
  return t('agent.engagement.draftingCoverLetterWithTab', {
    defaultValue: 'Drafting your cover letter for **{{title}}** at **{{company}}**. See the **{{tab}}** tab.',
    title,
    company,
    tab,
  });
}

export function letterRefusalErrorMessage(): string {
  return t(
    'agent.engagement.letterRefusal',
    'The letter generator refused this request (usually when your profile has very little work history). Add experience in your profile, or type **add sample experience** while the resume canvas is open, then ask again.',
  );
}

export function coverLetterReadyMessage(): string {
  const tab = t('agent.canvas.tabs.coverLetter', 'Cover Letter');
  const activities = t('agent.engagement.hub.myActivities', 'My Activities — track applications');
  const lead = t('agent.engagement.coverLetterReady', {
    defaultValue: 'Your cover letter is ready in the **{{tab}}** tab and saved to **{{activities}}**.',
    tab,
    activities,
  });
  return `${lead}\n\n${t('agent.engagement.nextSteps.title', '**What would you like to do next?**')}`;
}

export function applicationNoteReadyMessage(): string {
  const tab = t('agent.canvas.tabs.applicationNote', 'Application Note');
  const activities = t('agent.engagement.hub.myActivities', 'My Activities — track applications');
  return t('agent.engagement.applicationNoteReady', {
    defaultValue: 'Your application note is ready in the **{{tab}}** tab and saved to **{{activities}}**.\n\nReady to apply, or would you like to refine anything first?',
    tab,
    activities,
  });
}

export function refineCoverLetterPrompt(): string {
  return t(
    'agent.engagement.refineCoverPrompt',
    'What would you like to change? E.g. "Make it shorter", "Add my AWS experience", "More formal tone".',
  );
}

export function refineSectionPrompt(): string {
  return t(
    'agent.engagement.refineSectionPrompt',
    'What would you like to change? E.g. "Make bullet 1 more metrics-focused" or "Emphasize cloud experience"',
  );
}
